
import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import api from '../mainApi';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api/';
const ROOT_URL = API_BASE_URL.replace(/\/api\/?$/, '');

const Trainers = () => {
  const [trainers, setTrainers] = useState([]);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [specialty, setSpecialty] = useState('');
  const [password, setPassword] = useState('');
  const [address, setAddress] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [picture, setPicture] = useState(null);
  const [documentPic, setDocumentPic] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedTrainer, setSelectedTrainer] = useState(null);

  useEffect(() => {
    api.get('trainers')
      .then(res => setTrainers(res.data))
      .catch(error => console.error('Error fetching trainers:', error));
  }, []);

  const handleFileChange = (e, type) => {
    if (type === 'picture') {
      setPicture(e.target.files[0]);
    } else if (type === 'documentPic') {
      setDocumentPic(e.target.files[0]);
    }
  };

  const addTrainer = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', name);
    formData.append('email', email);
    formData.append('password', password);
    formData.append('specialty', specialty);
    formData.append('address', address);
    formData.append('mobile_number', mobileNumber);
    if (picture) formData.append('picture', picture);
    if (documentPic) formData.append('document_pic', documentPic);

    api.post('trainers', formData)
    .then(res => {
      setTrainers([...trainers, res.data]);
      setName('');
      setEmail('');
      setSpecialty('');
      setPassword('');
      setAddress('');
      setMobileNumber('');
      setPicture(null);
      setDocumentPic(null);
    })
    .catch(error => {
      if (error.response && error.response.status === 409) {
          alert(error.response.data.message);
      }
      console.error('There has been a problem with your axios operation:', error);
    });
  };

  const deleteTrainer = (id) => {
    api.delete(`trainers/${id}`)
      .then(() => {
        setTrainers(trainers.filter(trainer => trainer.id !== id));
      })
      .catch(error => console.error('Error deleting trainer:', error));
  };

  const handleShowModal = (trainer) => {
    setSelectedTrainer(trainer);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedTrainer(null);
    setPicture(null);
    setDocumentPic(null);
  };

  const handleUpdateTrainer = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('name', selectedTrainer.name);
    formData.append('email', selectedTrainer.email);
    formData.append('specialty', selectedTrainer.specialty);
    formData.append('address', selectedTrainer.address || '');
    formData.append('mobile_number', selectedTrainer.mobile_number || '');
    if (picture) formData.append('picture', picture);
    if (documentPic) formData.append('document_pic', documentPic);
    if (!picture && selectedTrainer.picture) formData.append('picture_url', selectedTrainer.picture);
    if (!documentPic && selectedTrainer.document_pic) formData.append('document_pic_url', selectedTrainer.document_pic);

    api.put(`trainers/${selectedTrainer.id}`, formData)
      .then(res => {
        setTrainers(trainers.map(trainer => trainer.id === res.data.id ? res.data : trainer));
        handleCloseModal();
      })
      .catch(error => console.error('Error updating trainer:', error));
  };

  return (
    <div>
      <h2>Trainers</h2>
      <form onSubmit={addTrainer} autoComplete="off">
        <div className="row gy-2 mb-3">
          <div className="col-md-3">
            <input type="text" className="form-control" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="col-md-3">
            <input type="email" className="form-control" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="new-password" required />
          </div>
          <div className="col-md-3">
            <input type="text" className="form-control" placeholder="Specialty" value={specialty} onChange={(e) => setSpecialty(e.target.value)} required />
          </div>
          <div className="col-md-3">
            <input type="password" className="form-control" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" required />
          </div>
          <div className="col-md-3">
            <input type="text" className="form-control" placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} />
          </div>
          <div className="col-md-3">
            <input type="text" className="form-control" placeholder="Mobile Number" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} autoComplete="off" />
          </div>
          <div className="col-md-3">
            <label htmlFor="pictureUpload" className="form-label">Picture</label>
            <input type="file" className="form-control" id="pictureUpload" accept="image/*" onChange={(e) => handleFileChange(e, 'picture')} />
          </div>
          <div className="col-md-3">
            <label htmlFor="documentPicUpload" className="form-label">Document Picture</label>
            <input type="file" className="form-control" id="documentPicUpload" accept="image/*" onChange={(e) => handleFileChange(e, 'documentPic')} />
          </div>
          <div className="col-md-3 d-flex align-items-end">
            <button type="submit" className="btn btn-primary w-100">Add Trainer</button>
          </div>
        </div>
      </form>

      <hr />

      <table className="table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Specialty</th>
            <th>Address</th>
            <th>Mobile</th>
            <th>Picture</th>
            <th>Document</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {trainers.map(trainer => (
            <tr key={trainer.id}>
              <td>{trainer.id}</td>
              <td>{trainer.name}</td>
              <td>{trainer.email}</td>
              <td>{trainer.specialty}</td>
              <td>{trainer.address}</td>
              <td>{trainer.mobile_number}</td>
              <td>
                {trainer.picture && <img src={`${ROOT_URL}${trainer.picture}`} alt="Trainer" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />}
              </td>
              <td>
                {trainer.document_pic && <img src={`${ROOT_URL}${trainer.document_pic}`} alt="Document" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />}
              </td>
              <td>
                <button className="btn btn-primary btn-sm me-2" onClick={() => handleShowModal(trainer)}>Edit</button>
                <button className="btn btn-danger btn-sm" onClick={() => deleteTrainer(trainer.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedTrainer && (
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Trainer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={handleUpdateTrainer} autoComplete="off">
              <div className="mb-3">
                <label htmlFor="name" className="form-label">Name</label>
                <input type="text" className="form-control" id="name" value={selectedTrainer.name} onChange={(e) => setSelectedTrainer({ ...selectedTrainer, name: e.target.value })} required />
              </div>
              <div className="mb-3">
                <label htmlFor="email" className="form-label">Email</label>
                <input type="email" className="form-control" id="email" value={selectedTrainer.email} onChange={(e) => setSelectedTrainer({ ...selectedTrainer, email: e.target.value })} autoComplete="new-password" required />
              </div>
              <div className="mb-3">
                <label htmlFor="specialty" className="form-label">Specialty</label>
                <input type="text" className="form-control" id="specialty" value={selectedTrainer.specialty} onChange={(e) => setSelectedTrainer({ ...selectedTrainer, specialty: e.target.value })} required />
              </div>
              <div className="mb-3">
                <label htmlFor="address" className="form-label">Address</label>
                <input type="text" className="form-control" id="address" value={selectedTrainer.address || ''} onChange={(e) => setSelectedTrainer({ ...selectedTrainer, address: e.target.value })} />
              </div>
              <div className="mb-3">
                <label htmlFor="mobileNumber" className="form-label">Mobile Number</label>
                <input type="text" className="form-control" id="mobileNumber" value={selectedTrainer.mobile_number || ''} onChange={(e) => setSelectedTrainer({ ...selectedTrainer, mobile_number: e.target.value })} autoComplete="off" />
              </div>
              <div className="mb-3">
                <label htmlFor="pictureUpload" className="form-label">Picture</label>
                <input type="file" className="form-control" id="pictureUpload" accept="image/*" onChange={(e) => handleFileChange(e, 'picture')} />
                {selectedTrainer.picture && !picture && <img src={`${ROOT_URL}${selectedTrainer.picture}`} alt="Current Picture" style={{ width: '50px', height: '50px', objectFit: 'cover', marginTop: '10px' }} />}
              </div>
              <div className="mb-3">
                <label htmlFor="documentPicUpload" className="form-label">Document Picture</label>
                <input type="file" className="form-control" id="documentPicUpload" accept="image/*" onChange={(e) => handleFileChange(e, 'documentPic')} />
                {selectedTrainer.document_pic && !documentPic && <img src={`${ROOT_URL}${selectedTrainer.document_pic}`} alt="Current Document" style={{ width: '50px', height: '50px', objectFit: 'cover', marginTop: '10px' }} />}
              </div>
              <Button variant="primary" type="submit">
                Save Changes
              </Button>
            </form>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default Trainers;
